const FlowText = () => {
  return (
    <div className="relative w-full h-fit text-white">
      <div className="relative w-full h-fit mx-auto flex items-center">
        <div className="relative w-fit min-w-48 h-fit hidden lg:block border-r-2 mr-5">
          <p className="text-lg text-point">
            <span>실시간&nbsp;견적문의&nbsp;현황&nbsp;&nbsp;</span>
          </p>
        </div>
        <div className="relative w-fit h-fit flow-text">
          <ul className="flex gap-5 flow-wrap text-lg">
            <li>
              <span className="">김00</span> (누수탐지)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">이00</span>(누수공사)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">오00</span>(누수공사)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">신00</span>(누수공사)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">임00</span>(누수탐지)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">김00</span> (누수탐지)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">이00</span> (누수탐지)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">오00</span> (누수공사)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">신00</span> (누수탐지)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">임00</span> (누수공사)&nbsp;&nbsp;|
            </li>
          </ul>
          <ul className="flex gap-5 flow-wrap text-lg">
            <li>
              <span className="">김00</span> (누수탐지)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">이00</span>(누수공사)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">오00</span>(누수공사)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">신00</span>(누수공사)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">임00</span>(누수탐지)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">김00</span> (누수공사)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">이00</span> (누수탐지)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">오00</span> (누수탐지)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">신00</span> (누수탐지)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">임00</span> (누수공사)&nbsp;&nbsp;|
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FlowText;
